// @ts-ignore: idb types are installed but TS cannot find them
import { openDB, DBSchema, IDBPDatabase } from 'idb';
import type { TMessage } from '@/models/CopilotChat';

interface CopilotDB extends DBSchema {
  messages: {
    key: string; // thread id ou 'default'
    value: TMessage[];
  };
}

const DB_NAME = 'copilot-chat-db';
const STORE_NAME = 'messages';

export const getThreadId = async () => {
  const db = await getDb();
  return db.get(STORE_NAME, 'default');
};

export const getDb = async () => {
  return openDB<CopilotDB>(DB_NAME, 1, {
    upgrade(db: IDBPDatabase<CopilotDB>) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    },
  });
};

export const saveMessages = async (key: string, messages: TMessage[], push = true) => {
  const db = await getDb();
  if (push) {
    const existingMessages = (await db.get(STORE_NAME, key)) || [];
    // Cria um mapa para evitar duplicatas pelo campo id e sender
    const messageMap = new Map<string, TMessage>();
    const getKey = (msg: TMessage) => `${msg.id}-${msg.sender}`;
    for (const msg of existingMessages) messageMap.set(getKey(msg), msg);
    for (const msg of messages) messageMap.set(getKey(msg), msg);
    await db.put(STORE_NAME, Array.from(messageMap.values()), key);
  } else {
    await db.put(STORE_NAME, messages, key);
  }
};

export const setResponseFeedback = async (key: string, internal_id: string, responseFeedback: boolean) => {
  const db = await getDb();
  const existingMessages = await db.get(STORE_NAME, key);
  const updatedMessages = existingMessages?.map((message) => ({
    ...message,
    response_feedback: message.id === internal_id ? responseFeedback : message.response_feedback,
  }));
  if (!updatedMessages) throw new Error('No messages found');
  await db.put(STORE_NAME, updatedMessages, key);
};

export const getMessages = async (key: string): Promise<TMessage[]> => {
  const db = await getDb();
  return (await db.get(STORE_NAME, key)) || [];
};

export const clearMessages = async (key: string) => {
  const db = await getDb();
  await db.delete(STORE_NAME, key);
};

export const clearAllMessages = async () => {
  const db = await getDb();
  await db.clear(STORE_NAME);
};

